import {Action, ActionData, ActionHandler} from '../../common/actions/action.model';
import {Record} from '../../common/record/record.model';
import {Panel, VisibilityLogicTriggeringStatus} from '../../common/metadata/metadata.model';

export interface PanelVisibilityLogicActionData extends ActionData {
  panel: Panel,
  context: {
    record?: Record,
    triggeringStatus: VisibilityLogicTriggeringStatus
  }
}

export abstract class PanelVisibilityLogicActionHandler extends ActionHandler<PanelVisibilityLogicActionData> {

  abstract run(data: PanelVisibilityLogicActionData, action: Action): void;

  shouldDisplay(_data: PanelVisibilityLogicActionData): boolean {
    return true
  };
}
